<template>
  <div class="chip-wrapper">
    {{ chipText }}
  </div>
</template>
<script>
export default {
  props: {
    chipText: String
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/palette';
.chip-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid map-get($spring-green, 400);
  background: map-get($spring-green, 50);
  padding: 4px 8px;
  border-radius: 1.5rem;
  width: -moz-max-content;
  white-space: nowrap;
  width: max-content;
  font-size: 10px;
  font-weight: 400;
  height: 20px;
  margin: auto;
}
</style>
